/* eslint-disable no-console */
import { getURLFromIPFSURI, Node } from './ipfs';
import { preview } from './wallet';

export const sanitiseProfileImage = (uri = '') => {
  if (uri && uri.indexOf('ipfs://') !== -1) {
    return getURLFromIPFSURI(uri, Node.INFURA);
  }

  // otherwise its already resolved
  return uri;
};

export const getUserName = (id: string, name: string) => {
  let userName = name === id ? preview(id) : `@${name}`;
  userName = preview(id); // eventually remove
  return userName;
};

export const getScreenName = (verified: boolean, screenName: string, id: string, name: string) => {
  // validate empty screen name before
  let parsedScreenName = screenName;
  // if screen name is null we fill it with the address
  if (!screenName) {
    parsedScreenName = preview(id);
  }

  return verified ? parsedScreenName : getUserName(id, name);
};
